import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import * as styles from './ProgressBar.module.scss';
export const ProgressBar = ({ progress, theme = 'light', className, 'aria-label': ariaLabel, }) => {
    const value = +(Math.max(0, Math.min(progress, 1)) * 100).toFixed(2);
    return (_jsx("div", { role: "progressbar", "aria-label": ariaLabel || 'Progress', "aria-valuenow": value, "aria-valuemin": 0, "aria-valuemax": 100, className: clsx([
            styles.rail,
            theme === 'dark' && styles.dark,
            className,
        ]), children: _jsx("div", { className: styles.track, style: { width: `${value}%` } }) }));
};
